import { Directive, ElementRef, Renderer2 } from '@angular/core'
import { filter, tap } from 'rxjs/operators'
import { MbConstants } from '../../../shared/mb-constants'
import { CartCheckoutService } from '../../services/mb-cart-checkout.service'
import { MbCheckoutTypes } from '../../../models'
import { ActiveCartService } from '@spartacus/cart/base/core'
import { Cart } from '@spartacus/cart/base/root'

@Directive()
export class MbSubmitOrderBase {

  cart$ = this.activeCartService.getActive().pipe(
    tap(cart => {
      if (cart?.totalItems === 0 || Object.keys(cart).length === 0) {
        this.renderer.addClass(this.elemRef?.nativeElement, 'hide-submit-component')
      } else {
        this.renderer.removeClass(this.elemRef?.nativeElement, 'hide-submit-component')
      }
    }),
    filter(cart => !!cart && Object.keys(cart).length !== 0),
    tap(cart => {
      this.isPurchaseCheckout = cart?.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_D ||
        cart?.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_E
      this.shouldDisplayPaymentProvider = !cart?.paymentDetails?.paymentMode?.poPaymentMode || false
    })
  )
  constants = MbConstants
  mbCheckoutType = MbCheckoutTypes
  isPurchaseCheckout = false
  shouldDisplayPaymentProvider = false

  constructor (protected activeCartService: ActiveCartService,
              protected elemRef: ElementRef,
              protected renderer: Renderer2,
              protected cartCheckoutService: CartCheckoutService) {
  }

  getTotalQuantityOfTypeOfItems (type: string, cart: Cart) {
    return this.cartCheckoutService.getTotalQuantityOfTypeOfItems(type, cart)
  }
}
